{
  "applications": {
    "all_up": "tout est disponible",
    "applications": "Applications",
    "instances": "Instances",
    "some_down": "instances inaccessibles",
    "last_update": "Dernière mise à jour",
    "loading_applications": "Chargement des applications...",
    "no_applications_registered": "Aucune application enregistrée.",
    "notifications_suppressed_for": "Les notifications sur <code>{name}</code> sont supprimées",
    "restricted": "limité",
    "server_connection_failed": "Echec de la connexion au serveur.",
    "suppress_notifications_on": "Supression des notifications sur <code>{name}</code>",
    "status": "Statut",
    "label": "Applications",
    "up": "OK",
    "shutdown": "Shutdown application <code>{name}</code>?",
    "restart": "Restart application <code>{name}</code>?",
    "restarted": "Successfully restarted application <code>{name}</code>"
  },
  "instances": {
    "shutdown": "Shutdown instance <code>{name}</code>?",
    "open_details": "Ouvrir les détails de l'instance",
    "restart": "Restart instance <code>{name}</code>?",
    "restarted": "Successfully restarted instance"
  }
}
